import React from 'react'
import PropTypes from 'prop-types'
import Modal from 'components/shared/modal'

const QuestionModal = ({ title, titleClassName, onClickYes, confirmTitle = 'Yes', cancelTitle = 'No', onClose, children, cancelClass, confirmClass, actionClass }) => (
  <Modal title={title} contentClassName="" onClose={onClose} titleClassName={titleClassName} headerClose={false}>
    {children}
    <div className={actionClass}>
      <button type="button" className={cancelClass} onClick={onClose}>
        {cancelTitle}
      </button>
      <button type="button" className={confirmClass} onClick={onClickYes}>
        {confirmTitle}
      </button>
    </div>
  </Modal>
)

QuestionModal.propTypes = {
  title: PropTypes.string,
  onClickYes: PropTypes.func,
  onClose: PropTypes.func.isRequired,
  confirmTitle: PropTypes.string,
  cancelTitle: PropTypes.string,
  titleClassName: PropTypes.string,
  children: PropTypes.node,
  cancelClass: PropTypes.string,
  confirmClass: PropTypes.string,
  actionClass: PropTypes.string,
}

QuestionModal.defaultProps = {
  cancelClass: 'btn bg-cancel text-white mx-2 px-7 py-2',
  confirmClass: 'btn btn-primary mx-2 px-7 py-2',
  actionClass: 'flex justify-end items-center bg-secondary-lightgray py-5'
}

export default QuestionModal
